import { useEffect, useRef } from 'react'

import { useCallbackEvent } from './use-callback-event'

export function useTimeout(callback: () => void, delay?: number | null): void {
  const timerCallback = useCallbackEvent(callback)
  const timerRef = useRef<NodeJS.Timeout | null>(null)

  // Set up the timeout.
  useEffect(() => {
    if (typeof delay !== 'number' || delay < 0) {
      return
    }

    timerRef.current = setTimeout(timerCallback, delay)
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay])
}
